import "./PrimaryButton.css"
import LoadingIndicator from "../loadingIndicator/LoadingIndicator";

export default function PrimaryButton(props) {
    const onClick = props.onClick
    const name = props.name
    const extraClassName = (props.extraClassName || "").trim()
    const text = props.children
    const disabled = props.disabled || false
    const isLoading = props.isLoading || false

    let className = "button bg-primary-500 hover:bg-primary-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
    className = [className, extraClassName].join(" ")
    return (
        <button
            disabled={disabled}
            name={name}
            type="submit"
            onClick={onClick}
            className={className}
        >
            {text} {isLoading ? <LoadingIndicator width={20} height={20} /> : <></>}
        </button>
    );
}